import { newE2EPage } from "@stencil/core/testing";

describe("Button Component", () => {
    describe("as button", () => {
        describe("attribute", () => {
            it("with label", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button label="Label"></ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with label as slot", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button>Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with variant", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button variant="primary">Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with size", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button variant="primary" size="default">Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with icon-placement", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button variant="primary" size="default" iconPlacement="end">Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with type", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            variant="primary"
                                            size="default"
                                            type="submit"
                                            iconPlacement="end"
                                            >Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with name type", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            variant="primary"
                                            size="default"
                                            type="submit"
                                            iconPlacement="end"
                                            name="someName"
                                            >Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with label visibility", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            variant="primary"
                                            size="default"
                                            type="submit"
                                            iconPlacement="end"
                                            icon="chevron-right"
                                            label-visibility="s"
                                            label="label"
                                            ></ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with multiline", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            variant="primary"
                                            size="default"
                                            type="submit"
                                            mulitline
                                            iconPlacement="end"
                                            name="someName"
                                            >Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with disabled", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            disabled
                                            >Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with disabled=false (should remove the disabled attribute)", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            disabled="false"
                                            >Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
        });
    });
    describe("as link", () => {
        describe("attribute", () => {
            it("with label", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button href="#" label="Label"></ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with label as slot", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button href="#">Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with variant", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button href="#" variant="primary">Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with size", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button href="#" variant="primary" size="default">Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with icon-placement", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button href="#" variant="primary" size="default" iconPlacement="end">Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with type", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            variant="primary"
                                            size="default"
                                            href="#"
                                            type="submit"
                                            iconPlacement="end"
                                            >Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with name type", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            variant="primary"
                                            size="default"
                                            href="#"
                                            type="submit"
                                            iconPlacement="end"
                                            name="someName"
                                            >Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with multiline", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            variant="primary"
                                            href="#"
                                            size="default"
                                            type="submit"
                                            mulitline
                                            iconPlacement="end"
                                            name="someName"
                                            >Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with target", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button
                                            variant="primary"
                                            href="#"
                                            size="default"
                                            target="_blank"
                                            type="submit"
                                            mulitline
                                            iconPlacement="end"
                                            name="someName"
                                            >Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with download attribute", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button href="#" download>Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                const shadowRoot = el.shadowRoot;
                const innerATag = await shadowRoot.querySelector("a");
                expect(innerATag).toHaveAttribute("download");
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
        });
    });

    describe("as toggle", () => {
        describe("attribute", () => {
            it("with label", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button toggle label="Label"></ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with label as slot", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button toggle>Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with icon", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button toggle icon="chevron-right">Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with selected", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button toggle selected icon="chevron-right">Label</ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
        });
    });

    describe("as shadow button", () => {
        describe("attribute", () => {
            it("with label", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button class="ux-shadow-button label="Label"></ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
            it("with icon", async () => {
                const page = await newE2EPage();
                await page.setContent(`<a href="" class="ux-shadow-button" ux-shadow-button--icon">
                                            <ux-icon name="cart-punching-tools"></ux-icon>
                                            Shadow Button Icon Link
                                            <ux-icon class="ux-shadow-button__arrow" name="arrow-small-right" />
                                        </a>`);
                const el = await page.findAll("ux-icon");
                await page.waitForChanges();
                expect(el[1]).toHaveClass("ux-shadow-button__arrow");
                expect(el).toMatchSnapshot();
            });
            it("disabled", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-button class="ux-shadow-button ux-shadow-button--disabled" label="Label">
                                        </ux-button>`);
                const el = await page.find("ux-button");
                await page.waitForChanges();
                expect(el).toHaveClass("hydrated");
                expect(el).toMatchSnapshot();
            });
        });
    });
});
